<template>
  <iLayout
    v-if="!loading"
    class="layout-wrapper"
  >
    <iHeader class="header">
      <HeaderMenu />
    </iHeader>
    <iLayout>
      <iSider
        v-model="sidebar.collapsed"
        :width="200"
        :collapsed-width="78"
        collapsible
        hide-trigger
        class="sidebar"
      >
        <SideBar :collapsed="sidebar.collapsed"/>
      </iSider>

      <iLayout class="main">
        <iHeader class="tabs-bar">
          <TabsBar />
        </iHeader>
        <Content class="content">
          <!-- <keep-alive> -->
          <router-view :key="$pageComponentNextKey" />
          <!-- </keep-alive> -->
        </Content>
      </iLayout>
    </iLayout>
  </iLayout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import pageComponent from '@/mixins/page-component';

import HeaderMenu from './AdminLayout/HeaderMenu.vue';
import SideBar from './AdminLayout/SideBar.vue';
import TabsBar from './AdminLayout/TabsBar.vue';

export default {
  name: 'AdminLayout',
  components: {
    HeaderMenu,
    SideBar,
    TabsBar,
  },
  mixins: [pageComponent],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState('Settings', ['sidebar']),
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions('Profile', ['fetchProfile']),
    async fetchData() {
      this.$Spin.show();
      try {
        this.loading = true;
        await Promise.all([
          this.fetchProfile(),
        ]);
        this.loading = false;
      } catch (e) {
        throw e;
      } finally {
        this.$nextTick(() => this.$Spin.hide());
      }
    },
  },
};
</script>

<style scoped>
.layout-wrapper {
  height: 100%;
  width: 100%;
}

.header {
  height: 50px;
  line-height: 50px;
  padding: 0 8px;
  z-index: 20;
}

.tabs-bar {
  height: 40px;
  line-height: inherit;
  padding: 0;
  background: #f0f0f0;
  box-shadow: 0 2px 1px 1px rgba(100,100,100,.1);
  z-index: 10;
}

.sidebar {
  overflow-x: hidden;
  z-index: 10;
}

.content {
  overflow-x: hidden;
  height: 100%;
}
</style>
